import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const StoreManage: AppRouteModule = {
  path: '/subsidyManage',
  name: 'SubsidyManage',
  identify: 'subsidyManage',
  component: LAYOUT,
  redirect: '/subsidyManage/subsidyIndex',
  meta: {
    icon: 'icon-park-outline:bank',
    title: '国补专享工具',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    // 列表页面
    {
      path: 'subsidyIndex',
      name: 'SubsidyIndex',
      component: () => import('@/views/subsidyManage/subsidyIndex/index.vue'),
      identify: 'subsidyIndex',
      meta: {
        title: '国补专享工具',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'subsidyIndex/:pageType/:order_num?/:storeNum',
      name: 'SubsidyIndexAdd',
      component: () => import('@/views/subsidyManage/subsidyIndex/add.vue'),
      identify: 'subsidyIndex',
      meta: {
        title: '订单详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/subsidyManage/subsidyIndex',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};
export default StoreManage;
